var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.690378 0.602234C0.497088 0.801047 0.497088 1.12339 0.690378 1.3222L4.64997 5.39492C4.74279 5.4904 4.86869 5.54403 4.99996 5.54403C5.13122 5.54403 5.25712 5.4904 5.34994 5.39492L9.30953 1.3222C9.50282 1.12338 9.50282 0.801046 9.30953 0.602234C9.11624 0.403422 8.80286 0.403422 8.60957 0.602234L4.99996 4.31498L1.39034 0.602234C1.19705 0.403422 0.883667 0.403422 0.690378 0.602234Z",
    fill: "#6C7275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownOutlinedIcon);
export default __webpack_public_path__ + "static/media/downOutlinedIcon.c35ce27fbc33902b19ffe90fc82ad555.svg";
export { ForwardRef as ReactComponent };